import React from "react";

import { Box, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import CloseIcon from "@mui/icons-material/Close";

import useLocalization from "../../hooks/useLocalization";

const ModalHeader = ({ title, subTitle, onClose }) => {
  const theme = useTheme();
  const { getTitle } = useLocalization();

  const consumeEvent = (event) => {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();
  };

  const handleCloseClick = (event) => {
    consumeEvent(event);
    if (typeof onClose === "function") {
      onClose(event);
    }
  };

  return (
    <Box
      height="40px"
      width="calc(100% - 2rem)"
      backgroundColor={theme.palette.primary.main}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
      }}
    >
      <Box>
        <Box>
          <Typography
            sx={{ fontSize: "14px", fontWeight: "bold" }}
            noWrap
          >
            {getTitle(title)}
          </Typography>
        </Box>

        {subTitle ? (
          <Box>
            <Typography
              sx={{ fontSize: "12px" }}
              noWrap
            >
              {getTitle(subTitle)}
            </Typography>
          </Box>
        ) : null}
      </Box>

      <IconButton
        onMouseDown={consumeEvent}
        onMouseUp={consumeEvent}
        onClick={handleCloseClick}
      >
        <CloseIcon sx={{ color: "#000" }} />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
